<template>
    <div class="container">
      <div class="content">
        
        <div class="search">
          <div class="search-input">
            <input class="input" type="text" v-model="searchContent" v-on:keyup.enter="getPostsList()" ref="searchInput">
          </div>
          <div class="search-logo">
            <svg t="1669918257736" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1369" width="28" height="28"><path d="M999.073 878.496L754.049 633.328c-2.856-2.856-6.056-5.032-9.032-7.312a402.928 402.928 0 0 0 65.488-220.72C810.617 181.512 629.249 0 405.361 0 181.481 0 0.001 181.504 0.001 405.304c0 223.912 181.48 405.304 405.248 405.304 81.488 0 157.144-24.24 220.8-65.608 2.288 3.08 4.456 6.168 7.2 8.912l245.024 245.056a85.064 85.064 0 0 0 60.344 25.032c21.824 0 43.656-8.344 60.344-24.92 33.368-33.256 33.368-87.32 0.112-120.584M405.369 682.704C252.457 682.704 128.001 558.24 128.001 405.304c0-152.816 124.456-277.288 277.36-277.288 152.92 0 277.256 124.472 277.256 277.4 0 152.816-124.456 277.288-277.248 277.288" p-id="1370" fill="#0057a3"></path></svg>
          </div>
        </div>

        <div class="theme-wrap" v-if="postsList.length != 0">
          <div class="item" @click="select(item.postsId)" v-for="(item,index) in postsList" :key="index" >
            <div class="item-title">{{item.postsTitle}}</div>
            <div class="item-time">{{item.postsTime.substring(0,10)}}</div>
          </div>
        </div>

        <div style="padding:20px 0px 20px 5px" v-if="pageMessage.pages > 1">
          <el-pagination
            :total="pageMessage.total"
            :page-size="15"
            @current-change="handCurrentChange" 
            :current-page="pageMessage.pageNum" 
            layout="prev, pager, next"
          >
          </el-pagination>
        </div>

        <!-- <div v-if="loading == true" style="text-align: center;font-size:40px;color:#7b7b7b;margin-top:7px">
          <i class="el-icon-loading"></i>
        </div> -->
        
        <!-- <div class="navigation" v-if="pageMessage.pages > 1">
          <div class="navigation-wrap">
            
            <div class="navigation-item" @click="pageNum = pageMessage.prePage" v-if="pageMessage.hasPreviousPage == true">上一页</div>
            
            <div class="navigation-item" v-for="(item,index) in pageMessage.navigatepageNums" :key="index">
              <div class="pageActive" v-if="item == pageMessage.pageNum">{{item}}</div>
              <div @click="pageNum = item" v-else>{{item}}</div>
            </div>
           
            <div v-if="pageMessage.pages - 2 >= 5 && pageMessage.pages - 3 > pageMessage.pageNum" style="margin: 0px 5px 0px 5px;font-weight: 500;">···</div>
            
            <div class="navigation-item" @click="pageNum = pageMessage.pages" v-if="pageMessage.pages - 1 >= 5 && pageMessage.pages - 2 > pageMessage.pageNum">{{pageMessage.pages}}</div>
  
            <div class="navigation-item" @click="pageNum = pageMessage.nextPage" v-if="pageMessage.hasNextPage == true">下一页</div>
          </div> 
        </div> -->
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Search",
  data() {
    return {

      pageNum:1,
      postsList:[],
      pageMessage:[],

      searchContent:"",
      categoryName:"",
      albumName:"",

      loading:false,

    };
  },
  mounted() {
    this.searchContent = this.$route.query.search
    this.getPostsList()
  },
  methods: {
    handCurrentChange(current){
      this.pageNum = current
      this.getPostsList()
    },
    getPostsList(){
      if(this.searchContent != ""){
        this.loading = true
        let formData = new FormData();
        formData.append("pageNum", this.pageNum);
        formData.append("categoryName", this.categoryName);
        formData.append("albumName", this.albumName);
        formData.append("searchContent", this.searchContent);
        var url = this.GLOBAL.URL+"/postsList"
        axios.post(url,formData).then((response) => {
          console.log(response.data);
          this.postsList = response.data.list
          this.pageMessage = response.data
          this.loading = false
        });
      }
    },
    select(postsId){  
      this.$router.push({
        path: '/detail',
        query: { 
          postsId: postsId,
        }
      })
    },
  },
  watch:{
    '$route' (to, from) {
      if(to.path == '/search' && to.query.search != this.searchContent){
        window.scrollTo(0, 0)
        this.searchContent = this.$route.query.search;
        this.postsList = []
        this.pageNum = 1,
        this.getPostsList()
      }
    },
    pageNum:{
      handler(newValue,oldValue){
        this.getPostsList()
      }
    }
  }
};
</script>

<style scoped>
.container{
  min-width: 1300px;
  max-width:1920px;
  margin:0px auto;
}
.content{
  padding: 120px 190px 20px 190px;
}
.search{
  /* width: 100%; */
  height: 55px;
  background-color: #fff;
  margin: 0px 0px 70px 0px;
  padding: 0px 20px 0px 20px;
  border-radius: 50px;
  box-shadow: 0px 0px 15px 0px rgba(92, 92, 92, 0.15);
  display: flex;
  align-items: center;
}
.search-logo{
  line-height: 0px;
}
.search-input{
  margin: 0px 60px 0px 20px;
  width: 100%;
}
.search-input input{
  background-color: #fff;
  color: #7f7f7f;
  width: 100%;
  border: 0;
  outline:0;
  font-size: 22px;
}
.content-none{
  text-align: center;
  margin: 100px 0px 0px 0px;
  color: #9b9b9b;
  font-weight: 500;
  font-size: 20px;
}
.theme-wrap{
  margin:20px;
  padding: 10px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.15);
  min-height: 45px;
}
.item{
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 10px 20px;
  cursor: pointer;
  border-radius: 20px;
  color: #6d6d6d;
  font-size: 16px;
}
.item-title{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}
.item-time{
  white-space: nowrap;
}
.item:hover{
  background-color: #f2f2f2;
}

.loadMore{
  text-align:center;
  color:#0058a4;
  margin-top:40px;
  cursor: pointer;
}

.navigation{
  margin-top: 20px;
  display: flex;
  user-select: none;
}
.navigation-wrap{
  padding:15px;
  display:flex;
  box-shadow: 0px 0px 15px 0px rgba(92, 92, 92, 0.1);
  border-radius: 20px;
  color: #0058a4;
}
.navigation-item{
  cursor: pointer;
  margin: 0px 5px 0px 5px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.pageActive{
  background-color:#0058a4;
  color:#fff;
  border-radius: 5px;
  width:20px;
  height:20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>